import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LoadingDropdownSettings } from 'app/shared/dynamic-forms/form-models/event-emitter-entities/loading-more-settings';
import { MultiSelectControl } from 'app/shared/dynamic-forms/form-models/multi-select-control';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'hb-df-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./dropdown-style.scss'],
})
export class MultiSelectComponent implements OnInit, OnDestroy {
  @Input() control: MultiSelectControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();
  
  private unsubscribe: Subject<boolean> = new Subject();
  readonly searchInputDebounceTime: number = 500;

  loading = false;
  input$ = new Subject<string>();
  settings = new LoadingDropdownSettings();

  ngOnInit(): void {
    this.onSearch();
  }
  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  fetchMore(): void {
    this.settings.startItemNumber = this.control.options.length;
    this.requestLoadItems();
  }

  private requestLoadItems(): void {
    this.control.requestLoadItems(this.settings);
  }

  private onSearch(): void {
    this.input$.pipe(debounceTime(this.searchInputDebounceTime), distinctUntilChanged(), takeUntil(this.unsubscribe)).subscribe(data => {
      this.settings.reset();
      this.settings.searchTerm = data;
      this.requestLoadItems();
    });
  }

  onClose(): void {
    if (this.settings.searchTerm) {
      this.input$.next(null);
    }
  }

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
